import Cookies from 'js-cookie'
import debounce from 'lodash.debounce';
import axios from 'axios';

import {ellipsizeTextBox} from './ellipsize_text_box';
import {ListingViolationReport} from './listing_violation_report';
import {markerManager} from './map/marker_manager';
import customMapControls from './map/custom_map_controls';
import {ListingGallery} from './listing_gallery';
import {AddToCollection} from './add_to_collection';
import {actions} from './actions';
import {selectListings} from './select_listings';
import {shareListing} from './share_listing';
import {ShowingInfo} from './showing_info';
import {translations} from './translations.js.erb'

const MINIMUM_MAP_WIDTH = 768;

var listing;
var currencySymbol;
var mapEnabled;
var map;
var loadedFragments = [];
let saveLink;
let hideLink;

function init(listingArg, options) {

  listing = listingArg;
  currencySymbol = options.currencySymbol;
  mapEnabled = options.mapEnabled;

  new ShowingInfo('.showingInfoLink');

  ListingGallery.init({height: 5, js_listing: window.js_listing, bindEvents: true});

  handlePageLayout();
  $(window).resize( debounce(handlePageLayout, 500) );


  /* If the body isn't scrollable, load these fragments immediately */
  /* Otherwise, load them on the first scroll event */
  if ($(document).height() >= $('body').height()) {
    loadInitialFragments();
    $('.c-card-group').flexCardGroup();
  } else {
    $(window).one('scroll', loadInitialFragments);
  }

  setTimeout(function(){
    // this shouldn't need a delay, but moving it one tick seems to sort out a
    // bug with height calculation that doesn't make much sense otherwise
    ellipsizeTextBox('.remarks');
  }, 0);

  $('#listingDetailMapButton').click(showMap);

  // Event handler for single listing header selection
  selectListings.init('.selectListingsControl');

  // agent dropdown menu links
  actions.recommendLink('.recommendLink', listing.ListingKey);
  actions.saveLink('.saveListingLink');
  actions.hideLink('.hideLink');
  
  ListingViolationReport.init('.reportViolation');

  new AddToCollection('.removeFromCollection', {successCallback: function(plugin){
    toast.success(translations.listings.actions.removed_successfully);
    plugin.$element.slideUp();
  }});

  $('#share-listing-action').click(function () {
    shareListing.getLink(listing);
  });

  loadEditButton();

  setUpSaveAndHideLinks();
  handlePostLoginCookieIfPresent();

  $('.shareLink').on('click', function(e){
    e.preventDefault();
    let url = new Url($(e.target).attr('href'));
    url.query.referrer = window.location.href;
    window.location.href = url;
  })
}

function setUpSaveAndHideLinks() {
  // set up consumer listing actions bar save and hide links
  saveLink = new AddToCollection('#save-listing-action', {
    successCallback: saveLinkSuccessCallback
  });
  // remove the listing from the hidden collection if necessary
  $('#save-listing-action').click(() => hideLink.remove());

  hideLink = new AddToCollection('#hide-listing-action', {
    successCallback: hideLinkSuccessCallback
  });  
  // remove the listing from the saved collection if necessary
  $('#hide-listing-action').click(() => saveLink.remove());
}

function saveLinkSuccessCallback(data) {
  const text = data.added ? translations.g.saved : translations.g.save;
  $('#save-listing-action').text(text);
}

function hideLinkSuccessCallback(data) {
  const text = data.added ? translations.g.hidden : translations.g.hide;
  $('#hide-listing-action').text(text);
}

function handlePostLoginCookieIfPresent() {
  let cookieVal = Cookies.get(AddToCollection.postLoginCookieName);

  if(typeof cookieVal !== 'undefined'){
    /* do this first so we don't get into a redirect loop */
    Cookies.remove(AddToCollection.postLoginCookieName);

    var collectionName = cookieVal.split(',')[0];
    /*
     * If the role is now vow/portal, the user logged in so we can add the
     * listing to the collection
     * If the role isn't one of those, they must have hit cancel on the login
     * screen, so we'll no-op here
     */
    if (Flexmls.currentUser.role === "vow" || Flexmls.currentUser.role === "portal") {

      // Since the user wasn't logged in, the buttons would have always shown
      // "Save" or "Hide". If the listing is already saved or hidden, we don't
      // need to do anything. The user's intention probably wasn't to unsave/unhide.
      if(collectionName === 'Favorites' && !saveLink.added){
        saveLink.$element.click();
      } else if(collectionName === 'Rejects' && !hideLink.added){
        hideLink.$element.click();
      }
    }
  }
}


function loadEditButton() {
  if( $('.editListingBtn').length > 0) {
    axios.get(routes.listing_permissions_path(listing.ListingKey)).then((response) => {
      if(response.data.Editable === true) {
        $('.editListingBtn').show();
      }
    });
  }
}

function loadInitialFragments() {
  // Fragments load in the order of 1)General, 2)tax/price history, 3)Rooms/Units
  // But, general contains both Main and Detail fields, and we want Rooms displayed between those two.
  // So, on callback for rooms, we use insertAfter to shift up Rooms, placing the Details card below it.
  loadReportFragments($('#report_general'));
  loadReportFragments($('#report_tax, #report_price_history'));
  loadReportFragments($('#report_room, #report_unit'), function() {
    $("#rooms_card").insertBefore('#report_general > div:last-child');
  });
}

function handlePageLayout() {
  if(window.innerWidth >= MINIMUM_MAP_WIDTH){
    initMap();
  }
}

function loadReportFragments(selector, successCallback) {
  if(typeof successCallback !== 'function') {
    successCallback = function() {};
  }
  $(selector).each(function(index, element) {
    var $elem = $(element);
    var id = $elem.attr('id');

    if(loadedFragments.indexOf(id) < 0){

      $elem.show().load($elem.data('fragment-path'), function(response, status, xhr) {
        if (status == "error") {
          // let Bugsnag pick this up
          throw xhr.status + ' '+ xhr.statusText;
        } else {
          loadedFragments.push(id);
          successCallback();
        }
      });

    }

  });
}

function initMap() {
  if(typeof map !== 'undefined' || !mapEnabled){
    return;
  }

  var mapOptions = {
    disableDefaultUI: true,
    zoom: 15,
    center: { 
      lat: listing.Latitude, 
      lng: listing.Longitude
    },
    gestureHandling: 'greedy'
  }
  map = new google.maps.Map(document.getElementById('listingDetailMap'), mapOptions);

  markerManager.init({map: {googleMap: map}});

  markerManager.addPriceMarker(listing, currencySymbol, {bindEvents: false});

  customMapControls.init({map: map});
  
  $('#closeMapButton').click(function(e) {
    e.preventDefault();
    $('body').removeClass('map-view');
  });
}

function showMap() {
  $('body').addClass('map-view');
  initMap();
}

export let ListingDetail = {
  init: init,
  // these functions are exposed for testing only
  _saveLinkSuccessCallback: saveLinkSuccessCallback,
  _hideLinkSuccessCallback: hideLinkSuccessCallback
};
